import type { FeatureName } from '@wix/thunderbolt-symbols'
import type { FeatureLoaderParams, FeaturesLoaders, ILoadFeatures } from './Features'
import type { IocContainer } from '@wix/thunderbolt-ioc'
import { yieldToMain } from '@wix/thunderbolt-commons'

export const createFeaturesLoader = (
	featuresLoaders: Partial<FeaturesLoaders>,
	featureLoaderParams: FeatureLoaderParams,
	{ pageFeaturesContext }: { pageFeaturesContext: 'page' | 'editorPage' }
): ILoadFeatures => {
	const loadFeaturesIntoContainer = (
		container: IocContainer,
		featureNames: Array<FeatureName>,
		context: 'site' | 'page' | 'editor' | 'editorPage'
	): Promise<any> =>
		Promise.all(
			featureNames.map(async (featureName) => {
				if (!featuresLoaders[featureName]) {
					console.error(`no feature loader for ${featureName}`)
				}
				await yieldToMain()
				const featureLoader = await featuresLoaders[featureName]!(featureLoaderParams)
				await yieldToMain()
				// @ts-ignore
				const loader = featureLoader[context]
				if (loader) {
					// @ts-ignore
					container.load(loader)
				}
			})
		)
	let pageFeatures = new Set<FeatureName>()
	return {
		getAllFeatureNames() {
			return Object.keys(featuresLoaders) as Array<FeatureName>
		},
		getLoadedPageFeatures() {
			return [...pageFeatures]
		},
		loadSiteFeatures: (container, featureNames) =>
			loadFeaturesIntoContainer(container, featureNames as Array<FeatureName>, 'site'),
		loadPageFeatures: (container, featureNames) => {
			pageFeatures = new Set([...pageFeatures, ...featureNames])
			return loadFeaturesIntoContainer(container, featureNames as Array<FeatureName>, pageFeaturesContext)
		},
		loadEditorFeatures: (container, featureNames) =>
			loadFeaturesIntoContainer(container, featureNames as Array<FeatureName>, 'editor'),
	}
}
